import React from 'react'
import { observer } from 'mobx-react'
import styled from 'styled-components'

type Props = {
  spacing: string
  bottomLine?: boolean
}

const Spacer: React.FC<Props> = observer(({ spacing, bottomLine }) => {
  return <StyleSpacer spacing={spacing} bottomLine={bottomLine} />
})

export default Spacer

const StyleSpacer = styled.div<{ spacing: string; bottomLine?: boolean }>`
  margin-top: ${(props) => props.spacing};
  @media (prefers-color-scheme: light) {
    border-bottom: ${(props) => (props.bottomLine ? 'solid 1px #F5F5F5' : null)};
  }
  @media (prefers-color-scheme: dark) {
    border-bottom: ${(props) => (props.bottomLine ? 'solid 1px #282829' : null)};
  }
`
